<template>
  <div class="bg-login">

    <div class="login-header container title">
      <div>
        <el-image style="width: 150px; height: 61px" src="../../static/Logo_WG.png" fit="scale-down"></el-image>
        <div style="font-size:30px;margin-bottom:5px;color:lightblue;padding-bottom:5px;">游戏联运商户数据管理系统</div>
      </div>
    </div>
    <div class="main">
        <div class="middle-box loginscreen bg-white">
            <div class="login-top">

            </div>
            <div class="container">
              <div class="login-title text-center" style="display:flex;align-items:center;justify-content:center;position:relative;">
                  <p style="color:block;font-size:20px;">平台入口</p>
                  <el-button v-if="showVerifySelect" type="text" class="title-back-btn" @click="goBackToLogin">
                    <i class="el-icon-arrow-left"></i> 返回
                  </el-button>
                  <el-button v-else-if="showSMSVerify || showPhoneRegister || showOtpSetup || showOTPVerify" type="text" class="title-back-btn" @click="goBackToSelect">
                    <i class="el-icon-arrow-left"></i> 返回
                  </el-button>
              </div>

              <!-- 验证方式选择 -->
              <div v-if="showVerifySelect" class="verify-select">
                <h2 class="verify-select-title">选择验证方式</h2>
                <div class="verify-select-buttons">
                  <el-button class="verify-option-btn" @click="selectSMS">
                    <i class="el-icon-message verify-option-icon"></i>
                    <span class="verify-option-text">SMS 短信认证</span>
                  </el-button>
                  <el-button class="verify-option-btn resetMgL0" @click="selectOTP">
                    <i class="el-icon-key verify-option-icon"></i>
                    <span class="verify-option-text">Authenticator OTP 认证</span>
                  </el-button>
                </div>
                <p class="verify-select-hint">
                  如果您因更换设备或手机号而无法获取验证码，请联系平台管理员。  
                </p>
              </div>

              <!-- SMS 短信验证码 -->
              <sms-verify
                v-if="showSMSVerify"
                ref="smsVerifyRef"
                :phone="smsPhone"
                :user-info="userInfo"
                sms-send-code-url="coupon-system/sms/sendCodeByPhone"
                sms-verify-code-url="coupon-system/sms/verifyCodeByPhone"
                :auto-send="smsAutoSend"
                :show-back-btn="true"
                @verify-success="handleSmsVerifySuccess"
                @go-back="goBackToSelect"
              />

              <!-- 手机号注册 -->
              <phone-register
                v-if="showPhoneRegister"
                :user-info="userInfo"
                sms-send-code-url="coupon-system/sms/sendCodeByPhone"
                sms-verify-code-url="coupon-system/sms/verifyCodeByPhone"
                upd-phone-url="coupon-system/updPhone"
                :show-back-btn="true"
                @register-success="handlePhoneRegisterSuccess"
                @go-back="goBackToSelect"
              />

              <!-- OTP 设置组件（新用户） -->
              <otp-setup
                v-if="showOtpSetup"
                :user-info="userInfo"
                get-mfa-secret-url="coupon-system/otp/getMfaSecret"
                :show-back-btn="true"
                @next-step="handleOtpSetupNext"
                @go-back="goBackToSelect" />

              <!-- OTP 验证组件（老用户） -->
              <otp-verify
                v-if="showOTPVerify"
                ref="otpVerifyRef"
                :email="loginForm.userbh"
                :token-obj="userInfo"
                type="login"
                :show-back-btn="true"
                @verify-success="handleOtpVerifySuccess"
                @go-to-setup="handleGoToSetup"
                @go-back="goBackToSelect" />

              <!-- 登录表单 -->
              <el-form v-if="!showVerifySelect && !showSMSVerify && !showPhoneRegister && !showOtpSetup && !showOTPVerify" :model="loginForm" :rules="loginRules" ref="loginForm" @submit.native.prevent>
                  <el-form-item prop="userbh">
                      <el-input name="userbh" v-model="loginForm.userbh" placeholder="请输入用户名/手机号" v-focus auto-complete="on"></el-input>
                  </el-form-item>

                  <el-form-item prop="password" style="margin-bottom:5px">
                      <el-input name="password" type="password" v-model="loginForm.password" placeholder="请输入密码" auto-complete="on"></el-input>
                  </el-form-item>

                  <el-form-item style="margin-bottom:5px">
                    <el-link :href="merchantLoginUrl" style="float:right;margin-right:10px;" :underline="false" type="success">商户登录</el-link>
                  </el-form-item>

                  <el-form-item>
                      <el-button class="bt-width" type="primary" @click="submitForm('loginForm')">登录</el-button>
                  </el-form-item>

              </el-form>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import Utils from '../js/utils.js'
import { merchantBaseUrl } from '../config/env.js'
import OtpVerify from './verifyOTP.vue'
import OtpSetup from './otpSetup.vue'
import SmsVerify from './smsVerify.vue'
import PhoneRegister from './phoneRegister.vue'
export default {
  name: "login",
  components: {
    OtpVerify,
    OtpSetup,
    SmsVerify,
    PhoneRegister
  },
  data() {
    return {
      loginForm: {
        userbh: '',
        password: '',
       },
       loginRules: {
        userbh: [
            {
              required: true,
              message: "请输入用户名",
              trigger: "blur"
            }
        ],
        password: [
           {
             required: true,
             message: '请输入密码',
             trigger: 'blur'
           }
        ]
      },
      loading: false,
      showOTPVerify: false,
      showOtpSetup: false,
      showVerifySelect: false,
      showSMSVerify: false,
      showPhoneRegister: false,
      userInfo: null,
      smsPhone: '',
      smsAutoSend: false
    }
  },
  computed: {
    // 计算商户登录链接
    merchantLoginUrl() {
      return `${merchantBaseUrl}/merch/login`;
    }
  },
  created () {
    document.onkeydown = (e) => {
      if (window.event === undefined) {
        var key = e.keyCode
      } else {
        // eslint-disable-next-line no-redeclare
        var key = window.event.keyCode
      }
      if (key === 13) {
        this.submitForm('loginForm');
      }
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('input').focus()
      }
    }
  },
  methods: {
    isObject(value) {
      return typeof value === 'object' && value !== null;
    },
    submitForm(formName) {
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.$ajax({
            url:"coupon-system/login",
            methods:'POST',
            async:false,
            data:{'userbh':_this.loginForm.userbh,'password':Utils.encrypt(_this.loginForm.password)},
            success:function(response){
              if (response.code==0) {
                let userInfo = response.data;
                if (_this.isObject(userInfo)) {
                  if(userInfo.hasOwnProperty('token')){
                    // 保存 token 到 sessionStorage
                    window.sessionStorage.setItem('token', userInfo.token);
                    // 保存用户信息供后续组件使用
                    _this.userInfo = userInfo;
                    // 登录成功后显示验证方式选择
                    _this.showVerifySelect = true;
                  }
                }else{
                  _this.$message.error("数据异常");
                }
              }else{
                _this.$message.error(response.data);
              }
            },
            error:function(){
              _this.$message.error("请求失败");
            }
          });
        } else {
          _this.$message.error('请查看输入是否正确!');
          _this.loading = false;
          return false;
        }
      });
    },
    // 返回登录表单（从验证方式选择或子页面返回）
    goBackToLogin() {
      this.showVerifySelect = false;
      this.showSMSVerify = false;
      this.showPhoneRegister = false;
      this.showOtpSetup = false;
      this.showOTPVerify = false;
      this.userInfo = null;
      this.smsPhone = '';
      this.smsAutoSend = false;
      window.sessionStorage.removeItem('token');
    },
    // 返回验证方式选择页面
    goBackToSelect() {
      this.showSMSVerify = false;
      this.showPhoneRegister = false;
      this.showOtpSetup = false;
      this.showOTPVerify = false;
      this.showVerifySelect = true;
    },
    // 选择SMS短信认证
    selectSMS() {
      this.showVerifySelect = false;
      if (this.userInfo && this.userInfo.phone) {
        // 有手机号，直接跳转短信验证码输入界面
        this.smsPhone = this.userInfo.phone;
        this.smsAutoSend = true;
        this.showSMSVerify = true;
        this.$nextTick(() => {
          if (this.$refs.smsVerifyRef) {
            this.$refs.smsVerifyRef.focusInput();
          }
        });
      } else {
        // 没有手机号，跳转手机号注册页面
        this.showPhoneRegister = true;
      }
    },
    // 选择Authenticator OTP认证
    selectOTP() {
      this.showVerifySelect = false;
      const _this = this;
      // 调用 otp/check 判断新老用户
      _this.$ajax({
        url: 'coupon-system/otp/check',
        methods: 'POST',
        async: false,
        data: { userid: _this.userInfo.id },
        token: _this.userInfo.token,
        success: function(response) {
          if (response.code === 0) {
            const data = response.data;
            if (data && data.otpType === 1) {
              // otpType=1：未绑定，跳转 otpSetup.vue
              _this.showOtpSetup = true;
            } else {
              // otpType=2：已绑定，直接跳转 OTP 验证码页面
              _this.showOTPVerify = true;
              _this.$nextTick(() => {
                _this.$refs.otpVerifyRef.focusInput();
              });
            }
          } else {
            _this.$message.error(response.message || '检查 OTP 状态失败');
          }
        },
        error: function() {
          _this.$message.error("请求失败");
        }
      });
    },
    // 手机号注册成功后返回登录界面重新登录
    handlePhoneRegisterSuccess(phone) {
      this.showPhoneRegister = false;
      // 更新 userInfo 中的 phone
      if (this.userInfo) {
        this.userInfo.phone = phone;
      }
      const _this = this;
      _this.$alert('手机号绑定成功，请重新登录', '提示', {
        confirmButtonText: '确定',
        type: 'success',
        showClose: false,
        callback: function() {
          // 重置状态，返回登录表单
          _this.userInfo = null;
          _this.smsPhone = '';
          _this.smsAutoSend = false;
          window.sessionStorage.removeItem('token');
        }
      });
    },
    // SMS 验证成功，进入系统
    handleSmsVerifySuccess(smsCode, userInfo) {
      this.queryMenu(userInfo);
    },
    handleOtpVerifySuccess(otpCode, response) {
      // OTP 验证成功后，进入系统
      let userInfo = response.data
      this.queryMenu(userInfo)
    },
    handleOtpSetupNext() {
      // 从设置页面跳转到 OTP 验证页面
      this.showOtpSetup = false;
      this.showOTPVerify = true;
      this.$nextTick(() => {
        this.$refs.otpVerifyRef.focusInput();
      });
    },
    handleGoToSetup() {
      // 从验证页面跳转到设置页面
      this.showOTPVerify = false;
      this.showOtpSetup = true;
    },
    queryMenu:function(userInfo){
      let roleId = userInfo.roleid;
      let token = userInfo.token;
      let _this = this;
      let index = 0;
      let home_path;
      this.$ajax({
        url:"coupon-system/menu/getAuthByRole",
        methods:'GET',
        async:false,
        data:{'roleId':roleId,'token':token},
        success:function(response){
          if (response.code == 0 && response.data != null) {
            try {
              let permissionsData = response.data;
              if (permissionsData.length === 0) {
                _this.$message({message: '未找到授权功能',type: 'success'});
                return;
              }
              window.sessionStorage.setItem("token",userInfo.token);
              //创建一个数组用来存储符合权限的路由
              let dataRouter = [];
              //循环遍历动态路由表的每一个路由
              for (let i=0;i<permissionsData.length;i++){
                 let data = {};
                 data['path'] = permissionsData[i].path;
                 data['name'] = permissionsData[i].name;
                 data['meta'] = permissionsData[i].meta;
                 data['component'] = _this.getViews(permissionsData[i].component);
                 //获取子集合
                 let childrens = permissionsData[i].children;
                 if (childrens == null) {
                   childrens = [];
                 }
                 let dataChildRouter = [];
                 for(let j=0;j<childrens.length;j++){
                   if(j == 0){
                     data['redirect'] = childrens[j].path;
                   }
                   if(index == 0){
                     home_path = childrens[j].path;
                     index = 1;
                   }
                   let cdata = {};
                   cdata['path'] = childrens[j].path;
                   cdata['name'] = childrens[j].name;
                   cdata['meta'] = childrens[j].meta;
                   cdata['menutype'] = childrens[j].menutype;
                   cdata['component'] = _this.getViews(childrens[j].component);

                   let childrens2 = childrens[j].children;
                   if (childrens2 != null) {
                     let dataChildRouter2 = [];
                     for(let k=0;k<childrens2.length;k++){
                       let cdata2 = {};
                       cdata2['path'] = childrens2[k].path;
                       cdata2['name'] = childrens2[k].name;
                       cdata2['meta'] = childrens2[k].meta;
                       cdata2['menutype'] = childrens2[k].menutype;
                       cdata2['component'] = _this.getViews(childrens2[k].component);
                       dataChildRouter2.push(cdata2);
                     }
                     cdata['children'] = dataChildRouter2;
                   }


                   dataChildRouter.push(cdata);
                 }
                 data['children'] = dataChildRouter;
                 dataRouter.push(data);
              }
              // 将路由信息存到sessionStorage里
              window.sessionStorage.setItem("home_path", home_path);
              window.sessionStorage.setItem("userbh",userInfo.userbh);
              window.sessionStorage.setItem("username",userInfo.username);

              window.sessionStorage.setItem("roleId",userInfo.roleid);
              window.sessionStorage.setItem("utype","pt");

              //保存用户信息
              _this.$store.dispatch('saveUserInfo', userInfo);
              //保存路由状态
              _this.$store.dispatch('saveDynamicRouter', true);
              _this.$router.options.routes = dataRouter;
              _this.$router.addRoutes(dataRouter);
              // 暂时屏蔽二次验证，直接进入首页
              // window.sessionStorage.setItem('pendingPhoneVerify', 'true');
              // window.sessionStorage.removeItem('phoneVerified');
              // _this.$router.push({path:'/phone_verify'});
              window.sessionStorage.setItem('phoneVerified', 'true');
              _this.$router.push({path:home_path});
            } catch (e) {
              console.log("系统异常",e);
            } finally {

            }
          } else {
            // token无效或数据为null，提示重新登录
            _this.$message.error(response.message || '请重新登录');
            window.sessionStorage.clear();
          }
        },
        error:function(){
          _this.$message.error('请重新登录');
          window.sessionStorage.clear();
        }
      });
    },
    getViews:function(path) {
      // return import('@/components/' + path);
      return resolve => {
        require.ensure([], (require) => {
          resolve(require('@/components/' + path))
        })
      }
    }
  },
  created:function(){
    let token = window.sessionStorage.getItem('token');
    let utype = window.sessionStorage.getItem('utype');
    let phoneVerified = window.sessionStorage.getItem('phoneVerified');
    if (token) { // 判断token是否存在
      if (utype === "pt") {
        // 暂时屏蔽二次验证
        // if (phoneVerified !== 'true') {
        //   window.sessionStorage.setItem('pendingPhoneVerify', 'true');
        //   this.$router.push({path:'/phone_verify'});
        //   return;
        // }
        let home_path = window.sessionStorage.getItem('home_path');
        this.$router.push({path:home_path});
      }
      if (utype === "mer") {
        this.$router.push({path:"/mer_home"});
      }
    }
  }
};
</script>

<style scoped>
.bg-login{
  background-color: #324057;
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
.main{
  display: flex;
  justify-content: center;
  /* width: 60%; */
  /* background-color: red; */
}
.container {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}
.title{
  display: flex;
  justify-content: center;
  align-items: end;
  /* font-size: 50px;
  font-weight: bold; */
  /* color: white;
  padding-bottom: 30px; */

}
.title-content{
  color: white;
  margin-right: 50px;
}
.bg-white{
    background-color: #ffffff;
    /* opacity: 0.8; */
}
.middle-box{
    max-width: 400px;
    width: 400px;
    /* z-index: 100;
    margin: 0 auto;
    padding-bottom: 10px; */
}
.loginscreen .middle-box{
    /* width: 300px; */
}
.login-top{
  background-color: #ffffff;
  height: 6px;
}
.login-title{
	font-weight:bold;
}
.login-header{
	height:265px;
}
.login-logo{
	margin-top:40px;
}
.login-logo-zh,
.login-logo-en{
	font-weight:bold;
	color:#3b3127;
}
.login-logo-zh{
	font-size:45px;
	font-family:"宋体";
}
.login-logo-en{
	font-size:21px;
	font-family:"Helvetica";
}
.middle-box{
  .el-input {
      display: inline-block;
  }
  .el-button {
      display: inline-block;
      width:100%;
  }
  .el-input__inner {
      text-align: center;
  }
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 2px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  user-select: none;
}
.bt-width{
  width: 100%;
}

/* 验证方式选择 */
.verify-select {
  text-align: center;
  padding: 20px 0;
}
.verify-select-title {
  font-size: 22px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 32px 0;
}
.verify-select-buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.verify-option-btn {
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 16px;
  border: 1px solid #DCDFE6;
  border-radius: 8px;
  transition: all 0.3s;
}
.verify-option-btn:hover {
  border-color: #409EFF;
  color: #409EFF;
}
.resetMgL0{
  margin-left: 0 !important;
}
.verify-option-icon {
  font-size: 24px;
}
.verify-option-text {
  font-size: 16px;
  font-weight: 500;
}

.verify-select-hint{
  font-size: 12px;
    color: #909399;
    line-height: 1.8;
    text-align: left;
}
.title-back-btn {
  position: absolute;
  right: 0;
  font-size: 14px;
  color: #909399;
  padding: 4px 8px;
  text-align: left;
}
.title-back-btn:hover {
  color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue